/* ENC Sorteos — interacciones del tema */
(function () {
  'use strict';

  /* ---------- Menú móvil ---------- */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-nav-toggle]');
    if (toggle) {
      var nav = document.querySelector('[data-site-nav]');
      if (nav) nav.classList.toggle('is-open');
    }
  });

  /* ---------- Countdown ---------- */
  function initCountdowns() {
    document.querySelectorAll('[data-countdown]').forEach(function (el) {
      var target = new Date(el.getAttribute('data-countdown')).getTime();
      if (isNaN(target)) return;

      var numEls = {
        days: el.querySelector('[data-cd="days"]'),
        hours: el.querySelector('[data-cd="hours"]'),
        minutes: el.querySelector('[data-cd="minutes"]'),
        seconds: el.querySelector('[data-cd="seconds"]')
      };

      function pad(n) { return (n < 10 ? '0' : '') + n; }

      function tick() {
        var diff = target - Date.now();
        if (diff <= 0) {
          diff = 0;
          el.classList.add('is-ended');
        }
        var s = Math.floor(diff / 1000);
        var d = Math.floor(s / 86400);
        var h = Math.floor((s % 86400) / 3600);
        var m = Math.floor((s % 3600) / 60);
        var sec = s % 60;
        if (numEls.days) numEls.days.textContent = pad(d);
        if (numEls.hours) numEls.hours.textContent = pad(h);
        if (numEls.minutes) numEls.minutes.textContent = pad(m);
        if (numEls.seconds) numEls.seconds.textContent = pad(sec);
      }
      tick();
      setInterval(tick, 1000);
    });
  }

  /* ---------- Selector de cantidad ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty]');
    if (!btn) return;
    var wrap = btn.closest('.qty-input');
    var input = wrap.querySelector('input');
    var val = parseInt(input.value, 10) || 1;
    val += btn.getAttribute('data-qty') === 'up' ? 1 : -1;
    if (val < 1) val = 1;
    input.value = val;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Aparición al hacer scroll ---------- */
  function initReveal() {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) return;
    var targets = document.querySelectorAll(
      '.steps > *, .trust-item, .gallery-item, .faq-item, .reglas-item, .winner-card, .winners-empty, ' +
      '.hero__copy, .hero__media, .cupo, .split > *, .premio-copy, .premio-media, .newsletter, .note-box, ' +
      '.premio-card, .producto-card, .confianza-bar__item, .bio-slide, .ubicacion-info, .ubicacion-media, ' +
      '.instr-item, .section > .container > .text-center'
    );
    if (!targets.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    targets.forEach(function (t) {
      t.classList.add('reveal');
      var sibs = t.parentNode ? t.parentNode.children : null;
      if (sibs) {
        var idx = Array.prototype.indexOf.call(sibs, t);
        if (idx > 0 && idx < 12) { t.style.transitionDelay = Math.min(idx * 55, 440) + 'ms'; }
      }
      io.observe(t);
    });
  }

  /* ---------- Números que cuentan hacia arriba ---------- */
  function animateNum(el) {
    var raw = el.getAttribute('data-num-raw') || el.textContent.trim();
    el.setAttribute('data-num-raw', raw);
    var m = raw.match(/[\d,]+(\.\d+)?/);
    if (!m) return;
    var target = parseFloat(m[0].replace(/,/g, ''));
    if (isNaN(target)) return;
    var prefix = raw.slice(0, m.index);
    var suffix = raw.slice(m.index + m[0].length);
    var dur = 1200, startTs = null;
    function fmt(n) { return Math.round(n).toLocaleString('en-US'); }
    function step(ts) {
      if (!startTs) startTs = ts;
      var p = Math.min((ts - startTs) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = prefix + fmt(target * eased) + suffix;
      if (p < 1) requestAnimationFrame(step);
      else el.textContent = raw;
    }
    el.textContent = prefix + '0' + suffix;
    requestAnimationFrame(step);
  }
  function initCountUp() {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) return;
    var els = document.querySelectorAll('.trust-item__num, .cupo__remaining');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { io.unobserve(e.target); animateNum(e.target); }
      });
    }, { threshold: 0.5 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Init ---------- */
  function init() { initCountdowns(); initReveal(); initCountUp(); }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
